import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { apiFetcher } from '@/data/fetcher'
import { DocumentForm } from '@/forms/DocumentForm'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { Settings } from '@/interfaces/Settings'

export default function InvoiceEditPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'invoice',
  })
  const { data: documentData, isLoading: invoicesLoading } = useSWR(
    id && `/api/v2/invoices/${id}`,
    apiFetcher,
  )
  const { data: settings, isLoading: settingsLoading } = useSWR<Settings>(
    `/api/v2/settings`,
    apiFetcher,
  )
  const title = `${t('edit.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/invoices',
        children: t('list.title'),
      },
      {
        href: `/invoice/${id}`,
        children: id as string,
      },
      {
        href: `/invoice/${id}/edit`,
        children: t('edit.breadcrumb'),
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {(invoicesLoading || settingsLoading) && (
        <Loading />
      )}

      {documentData && settings && (
        <DocumentForm
          type="invoice"
          documentData={documentData}
          settings={settings}
        />
      )}
    </>
  )
}
